import api from './axios';

export async function get_budget(categories_arr = [], summaryType = 'monthly') {
    try {
        const queryString = categories_arr.map(encodeURIComponent).join(',');
        const res = await api.get('/budget', {
            params: {
                categories: queryString,
                summaryType: summaryType
            }
        });
       
        return res.data;
    } catch (err) {
        throw err;
    }
}
